import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { service } from "../../rbac-consts";
import { default as AdminServiceDetailsContainer } from "./admin/serviceDetails/ServiceDetailsContainer";
import { default as ClientServiceDetailsContainer } from "./client/serviceDetails/ServiceDetailsContainer";

const ServicesDetailsWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={service.ADMIN}
        yes={() => (
          <AdminServiceDetailsContainer match={match} />
        )}
      />
      <Can
        role={user.roles}
        perform={service.USER}
        yes={() => (
          <ClientServiceDetailsContainer match={match} />
        )}
      />
    </>
  );
};

export default ServicesDetailsWrapper;